const DEFAULT_LOCALES = 'en';
const SUPPORTED_LOCALES = [
  {
    code: 'en',
    base: '/en',
    name: 'English',
    translations: '/locales/en-us.json',
  },
  {
    code: 'tc',
    base: '/tc',
    name: '繁體中文',
    translations: '/locales/zh-hk.json',
  },
  {
    code: 'sc',
    base: '/sc',
    name: '简体中文',
    translations: '/locales/zh-cn.json',
  },
];

export default {
  DEFAULT_LOCALES,
  SUPPORTED_LOCALES,
};
